// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;God gives the solitary a home<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and brings forth prisoners to songs of welcome,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but the rebellious inhabit a burning desert.<br> </p> </div></div>";
// Exports
module.exports = code;